import { GetTeam, Team } from "@redotech/redo-model/team";
import { ShopifyIntegration } from "@redotech/redo-shopify-common/shopify";
import { StorefrontPlatform } from "@redotech/redo-storefront-common/storefront-config";
import { createContext } from "react";

export type TeamContextValue =
  | (Team & {
      featureFlags: GetTeam["featureFlags"];
      platform: StorefrontPlatform;
      shopifyIntegration?: ShopifyIntegration;
      updatePermissionsLink?: string;
      ianaTimezone?: string;
    })
  | undefined;
export const TeamContext = createContext<TeamContextValue>(undefined);

export const ReloadTeamContext = createContext<(() => void) | undefined>(
  undefined,
);
